module.exports = __webpack_public_path__ + "img/gr-h-2.cead1147.png";